export { default as Field } from './Field.vue'
export const Icon = 'border_all'
